const Form = () => ({
  classList: {
    error: 'form-error'
  },

  /**
   * Custom form validation using constraint validation API.
   * https://caniuse.com/#feat=constraint-validation
   * Adds class .form-error to every input if invalid
   * Error handling is done in input atoms.
   * If all inputs are valid, submits form
   * @param {Object} event optional event
   * @param {Function} cb An optional callback that can be triggered instead of submitting the form if it's valid
   * @returns {void}
   * @memberof Form
   */
  validate(event, cb) {
    if (event) {
      event.preventDefault();
    }

    const isValid = this.formElements.reduce((acc, element) => {
      const valid = element.validity.valid || element.disabled;
      const formField = element.closest('.form__field');

      // check for formField, a honeypot input has no formField
      if (formField) {
        if (valid) {
          formField.classList.remove(this.classList.error);
        } else {
          formField.classList.add(this.classList.error);
        }
      }
      return valid && acc;
    }, true);

    if (cb) {
      cb(isValid);
    } else if (isValid) {
      this.$root.dispatchEvent(
        new CustomEvent('success', {
          detail: event
        })
      );
      this.$root.submit();
    }
  },

  initEventListeners() {
    this.formElements.forEach((element) =>
      element.addEventListener('focusin', () => {
        element.classList.remove(this.classList.error);
      })
    );
  },

  init() {
    this.formElements = [
      ...this.$root.querySelectorAll('input, select, textarea')
    ];
    this.initEventListeners();
  }
});

export default Form;
